// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2z5IQ","header":"MessagesList_header__32ZJA","chat":"MessagesList_chat__2rPt5"};